import { gql } from "@apollo/client";

export const GET_SURVEY_QUESTIONS = gql`
  query getSurveyQuestions {
    survey_question {
      survey_question_id
      question_id
      survey_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
      survey {
        survey_id
        name
        org_id
      }
    }
  }
`;

export const GET_SURVEY_QUESTION_BY_ID = gql`
  query getSurveyQuestionById($surveyQuestionId: uuid!) {
    survey_question_by_pk(survey_question_id: $surveyQuestionId) {
      survey_question_id
      question_id
      survey_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
      survey {
        survey_id
        name
        org_id
      }
    }
  }
`;

export const GET_SURVEY_QUESTIONS_BY_SURVEY_ID = gql`
  query getSurveyQuestionsBySurveyId($surveyId: uuid!) {
    survey_question(where: { survey_id: { _eq: $surveyId } }) {
      survey_question_id
      question_id
      survey_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
      survey {
        survey_id
        name
        org_id
      }
    }
  }
`;

export const GET_SURVEY_QUESTIONS_BY_QUESTION_ID = gql`
  query getSurveyQuestionsByQuestionId($questionId: uuid!) {
    survey_question(where: { question_id: { _eq: $questionId } }) {
      survey_question_id
      question_id
      survey_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
      survey {
        survey_id
        name
        org_id
      }
    }
  }
`;
